import jwt_decode from 'jwt-decode';

export  default  {

  user: {
    authenticated: false,
    access_token: ''
  },
  checkAuth() {
      const jwt = localStorage.getItem('access_token')
      if(jwt) {
          this.user.authenticated = true
      }
      else {
          this.user.authenticated = false
      }
  },
  getToken(){
      if (this.user.keycloak!==undefined) return this.user.keycloak.token;
      else return false
  },
  decoded(){
      if (this.user.keycloak!==undefined) return jwt_decode(this.user.keycloak.token);
      else return "empty";
  },
  setToken(user) {
      this.user = user;
      this.user.authenticated = true;
  },
  getUser(){
      return this.user;
  },
  isUserAdmin(){
      return this.user.keycloak.idTokenParsed.group.includes("/admin");
  },
  getUserGroups(){
    return this.user.keycloak.idTokenParsed.group.map(group => group.replace('/',''));
  },
  tokenExpired(){
    const now = new Date()
    const secondsSinceEpoch = Math.round(now.getTime() / 1000)
    return this.decoded().exp > secondsSinceEpoch ? false : true;
  }
}
